import { render } from "./salary-domiciliation-valid.vue?vue&type=template&id=447c4c15"
import script from "./salary-domiciliation-valid.vue?vue&type=script&lang=js"
export * from "./salary-domiciliation-valid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__